<p-panel header="{{ 'fs.res.common.projects' | hisUi }}">

    <!-- #anchor dynamic field container -->
    <ng-template #dynamicFieldContainer></ng-template>

    <div class="selectAndTableCombination">
        <his-plam [hisDdKey]="dDKey" [showLabelTop]="true">
            <p-autoComplete #content
				[disabled]="!editMode"
				[hisDdKey]="dDKey"
				[(ngModel)]="selectedProject"
				hisLazyDataSource="api/v1/fs/res/project/simple"
				field="defaulttext"
				[minLength]="1"
				(onSelect)="onSelectByAutocomplete()"
				class="autocompleteWidth100">
            </p-autoComplete>

            <his-search-select-popup
                [editMode]="editMode"
                searchConfigFile="{{SEARCH_CONFIG_MINI_PROJECT}}"
                [selectedOptions]="selectedProjects"
                selectedOptionsIdColumn="Project.lid"
                [showDeleteButton]="false"
                (selectedOptionsChange)="onSelectBySearchPopup($event)">
            </his-search-select-popup>
        </his-plam>

        <div class="clearer"></div>
        <div *ngIf="selectedProjects?.length > 0">
            <div class="clearAndSpace"></div>
            <p-table [value]="selectedProjects">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="header-no-wrap"
                            [pSortableColumn]="'defaulttext'">{{'fs.res.finance.project.Project.defaulttext' | hisUi}}
                            <p-sortIcon *ngIf="selectedProjects.length > 1" [field]="'defaulttext'"></p-sortIcon>
                        </th>
                        <th>{{'fs.res.project.Project.projectHeads' | hisUi}}</th>
                        <th class="header-no-wrap"
                            [pSortableColumn]="'startdate'">{{'fs.res.finance.project.Project.startdate' | hisUi}}
                            <p-sortIcon *ngIf="selectedProjects.length > 1" [field]="'startdate'"></p-sortIcon>
                        </th>
                        <th class="header-no-wrap"
                            [pSortableColumn]="'enddate'">{{'fs.res.finance.project.Project.enddate' | hisUi}}
                            <p-sortIcon *ngIf="selectedProjects.length > 1" [field]="'enddate'"></p-sortIcon>
                        </th>
                        <th>{{'fs.res.finance.project.teamMembers' | hisUi}}</th>
                        <th>{{'common.actions' | hisUi }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-index="rowIndex" let-project>
                    <tr>
                        <td>{{project.defaulttext}}</td>
                        <td>
							<span *ngFor="let member of project.members">
								<span *ngIf="member.positionType.id === 1">
									{{member.surname}}, {{member.firstname}}<br/>
								</span>
							</span>
                        </td>
                        <td>{{ project.startdate | date: dateFormat }}</td>
                        <td>{{ project.enddate | date: dateFormat }}</td>
                        <td>
							<span *ngFor="let member of project.members">
								<span *ngIf="member.positionType.id >= 2">
									{{member.surname}}, {{member.firstname}}<br/>
								</span>
							</span>
                        </td>
                        <td class="singleLine">
                            <!-- <a routerLink="/pub/project/view/{{project.id}}" hisImage="MAGNIFIER_DETAIL" [title]="'de.his.javang.show' | hisUi"></a> -->
                            <button (click)="removeProject(project)" hisImage="DELETE" [disabled]="!editMode"
                                    class="icon" title="{{'common.removeAssignmentOf' | hisUi:(project.defaulttext)}}"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <!-- #anchor dynamic field container -->
    <ng-template #dynamicFieldContainer></ng-template>
</p-panel>
